import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { ImageCropDialog } from "./ImageCropDialog";
import { isImageFile } from "./imageFiles";

const ImageEditorContext = createContext(null);

export const ImageEditorProvider = ({ children }) => {
  const [request, setRequest] = useState(null);
  const pending = useRef(null);
  const finish = useCallback((result) => {
    const resolve = pending.current; pending.current = null;
    setRequest(null); resolve?.(result);
  }, []);
  useEffect(() => () => { pending.current?.(null); }, []);
  const editImage = useCallback((file, options = {}) => {
    if (!isImageFile(file)) return Promise.resolve(file); // Audio/video stay untouched.
    pending.current?.(null);
    return new Promise((resolve) => {
      pending.current = resolve;
      setRequest({ file, options, id: `${Date.now()}-${Math.random()}` });
    });
  }, []);
  return <ImageEditorContext.Provider value={editImage}>
    {children}
    {request && <ImageCropDialog key={request.id} file={request.file} options={request.options} onFinish={finish} />}
  </ImageEditorContext.Provider>;
};

export const useImageEditor = () => {
  const editImage = useContext(ImageEditorContext);
  if (!editImage) throw new Error("ImageEditorProvider is required for image upload editing");
  return editImage;
};